import React from 'react';
import css from './transferBasketPanel.module.scss';
import { Paper } from '@material-ui/core';

interface ITransferBasketPanel {
    fullHeight?: boolean;
    onBlur?: () => void;
}

const TransferBasketPanel: React.FC<ITransferBasketPanel> = ({ fullHeight, onBlur, children }) => (
    <Paper onBlur={onBlur} className={fullHeight ? css.pickerPaperFullHeight : css.pickerPaper}>
        {children}
    </Paper>
);

export default TransferBasketPanel;
